module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.value) ? _c('div', {
    staticClass: "crawled-info--wrapper"
  }, [_c('div', {
    staticClass: "crawled-info--label"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('models.project_lead.crawled_infos.' + _vm.label)) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "crawled-info--value"
  }, [_vm._v("\n    " + _vm._s(_vm.value) + "\n  ")])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-356c02bf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataDisplay/CrawledInfo.vue
// module id = 1867
// module chunks = 0